import { Address } from './Address';

export class UserLight{
        firstName : string;
        lastName : string;
        id : number;
        userName : string;
        address : Address;
        password : string;
        sendNewPass : boolean;
        selected : boolean;
        email : string;
        craId : number;
        clientId : number;
        mobilePhone : string;
        officePhone : string;
        fax : string;
        title : string;
        clientName : string;
        prettyCreatedDate : string;
        locationIds : number[];
        locations : string[];
}


export class UserSetting{
        id : number;
        settingName : string;
        settingsJSON : string;
        userId : number;
}
